document.addEventListener('DOMContentLoaded', () => {
  initKultaPageLoader();
  initKultaTheme(document);
  syncKultaCartCount();
  initKultaAjaxPopstate();
});

document.addEventListener('shopify:section:load', (event) => {
  initKultaTheme(event.target);
});

const KULTA_FAVORITES_KEY = 'kulta:favorites';
const KULTA_RECENT_PRODUCTS_KEY = 'kulta:recent-products';
const KULTA_PRODUCT_TYPE_FILTER_ALIASES = {
  necklace: ['necklace', 'necklaces'],
  earrings: ['earrings', 'earring'],
  bracelet: ['bracelet', 'bracelets'],
  ring: ['ring', 'rings'],
  'layered-set': ['layered-set', 'layered-sets', 'layered-necklace', 'layered-necklaces'],
  'layered-necklace': ['layered-necklace', 'layered-necklaces'],
  bundle: ['bundle', 'bundles'],
};

function initKultaPageLoader() {
  const loader = document.querySelector('[data-kulta-page-loader]');
  if (!loader || loader.dataset.kultaLoaderReady) return;

  loader.dataset.kultaLoaderReady = 'true';
  let showTimer;
  let activeLoads = 0;
  let visibleSince = 0;

  const showLoader = (delay = 0) => {
    activeLoads += 1;
    window.clearTimeout(showTimer);
    showTimer = window.setTimeout(() => {
      visibleSince = Date.now();
      loader.classList.add('is-visible');
      document.body.classList.add('kulta-is-loading');
    }, delay);
  };

  const hideLoader = () => {
    activeLoads = Math.max(0, activeLoads - 1);
    if (activeLoads > 0) return;

    window.clearTimeout(showTimer);
    const remaining = visibleSince ? Math.max(0, 300 - (Date.now() - visibleSince)) : 0;

    window.setTimeout(() => {
      if (activeLoads > 0) return;
      loader.classList.remove('is-visible');
      document.body.classList.remove('kulta-is-loading');
      visibleSince = 0;
    }, remaining);
  };

  const forceHideLoader = () => {
    activeLoads = 0;
    window.clearTimeout(showTimer);
    loader.classList.remove('is-visible');
    document.body.classList.remove('kulta-is-loading');
    visibleSince = 0;
  };

  window.KultaLoader = { show: showLoader, hide: hideLoader, forceHide: forceHideLoader };

  if (loader.classList.contains('is-visible')) {
    visibleSince = Date.now();
    document.body.classList.add('kulta-is-loading');
    window.setTimeout(forceHideLoader, 150);
  }
}

function withKultaLoader(task, delay = 140) {
  const loader = window.KultaLoader;
  if (!loader) return Promise.resolve().then(task);

  let didShow = false;
  const timer = window.setTimeout(() => {
    didShow = true;
    loader.show();
  }, delay);

  return Promise.resolve()
    .then(task)
    .finally(() => {
      window.clearTimeout(timer);
      if (didShow) loader.hide();
    });
}

/* ── AJAX Collection Filtering ─────────────────────────────────────────── */

let kultaFilterController = null;

/* Re-apply the shopper's Dense view after an AJAX re-render (filter/sort/popstate)
   — the server always renders Comfortable as active, wiping the local choice. */
function restoreKultaDenseView(shell) {
  const g = shell.querySelector('[data-kulta-product-grid]');
  if (g) g.classList.add('is-dense');
  const db = shell.querySelector('[data-kulta-view="dense"]');
  const cb = shell.querySelector('[data-kulta-view="comfortable"]');
  if (db) db.classList.add('is-active');
  if (cb) cb.classList.remove('is-active');
}

async function kultaAjaxFilter(form) {
  const shell = form.closest('.kulta-collection-shell');
  if (!shell) {
    form.submit();
    return;
  }

  if (kultaFilterController) kultaFilterController.abort();
  kultaFilterController = new AbortController();

  const grid = shell.querySelector('[data-kulta-product-grid]');
  const wasDense = !!(grid && grid.classList.contains('is-dense'));
  const url = new URL(form.action || window.location.pathname, window.location.origin);

  new FormData(form).forEach((value, key) => {
    const v = String(value).trim();
    if (v !== '') url.searchParams.append(key, v);
  });

  // Preserve client-side filter params (necklace_type, etc.) from the current URL
  const formNames = new Set();
  form.querySelectorAll('[name]').forEach((el) => formNames.add(el.name));
  new URL(window.location.href).searchParams.forEach((value, key) => {
    if (!formNames.has(key) && key !== 'page') {
      url.searchParams.append(key, value);
    }
  });

  window.history.pushState({}, '', url);

  if (grid) {
    grid.style.transition = 'opacity 0.15s ease';
    grid.style.opacity = '0.4';
  }

  try {
    const response = await fetch(url.toString(), { signal: kultaFilterController.signal });
    if (!response.ok) throw new Error('Filter request failed');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newShell = doc.querySelector('.kulta-collection-shell');

    if (newShell) {
      shell.innerHTML = newShell.innerHTML;
      if (wasDense) restoreKultaDenseView(shell);
      initKultaTheme(shell);
      syncKultaClientTypeFilters();
    }
  } catch (error) {
    if (error.name === 'AbortError') return;
    window.location.href = url.toString();
  }
}

function initKultaAjaxPopstate() {
  if (document.documentElement.dataset.kultaAjaxPopstateReady) return;
  document.documentElement.dataset.kultaAjaxPopstateReady = 'true';

  window.addEventListener('popstate', () => {
    const shell = document.querySelector('.kulta-collection-shell');
    if (!shell) return;

    const gridEl = shell.querySelector('[data-kulta-product-grid]');
    const wasDense = !!(gridEl && gridEl.classList.contains('is-dense'));

    if (kultaFilterController) kultaFilterController.abort();
    kultaFilterController = new AbortController();

    fetch(window.location.href, { signal: kultaFilterController.signal })
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newShell = doc.querySelector('.kulta-collection-shell');
        if (newShell) {
          shell.innerHTML = newShell.innerHTML;
          if (wasDense) restoreKultaDenseView(shell);
          initKultaTheme(shell);
          syncKultaClientTypeFilters();
        }
      })
      .catch((error) => {
        if (error.name !== 'AbortError') window.location.reload();
      });
  });
}

function normalizeKultaClientFilterValue(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/_/g, '-')
    .replace(/\s+/g, '-');
}

function normalizeKultaClientFilterGroup(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
}

function getKultaClientFilterGroups(form) {
  const groups = new Set();

  form?.querySelectorAll('[data-kulta-client-filter-group]').forEach((item) => {
    const group = normalizeKultaClientFilterGroup(item.dataset.kultaClientFilterGroup);
    if (group) groups.add(group);
  });

  if (form?.querySelector('[data-kulta-client-availability-input]')) {
    groups.add('availability');
  }

  return Array.from(groups);
}

function getKultaClientFilterValues(form, group) {
  const key = normalizeKultaClientFilterGroup(group);
  if (!form || !key) return [];

  const url = new URL(window.location.href);
  const values = [];

  url.searchParams.getAll(key).forEach((entry) => {
    entry.split(',').forEach((value) => {
      const normalized = normalizeKultaClientFilterValue(value);
      if (normalized && !values.includes(normalized)) values.push(normalized);
    });
  });

  return values;
}

function getKultaClientFilterState(form) {
  return getKultaClientFilterGroups(form).reduce((state, group) => {
    state[group] = getKultaClientFilterValues(form, group);
    return state;
  }, {});
}

function setKultaClientFilterValues(form, group, values) {
  const key = normalizeKultaClientFilterGroup(group);
  if (!key) return;

  const nextValues = values
    .map(normalizeKultaClientFilterValue)
    .filter((value, index, list) => value && list.indexOf(value) === index);
  const url = new URL(window.location.href);

  url.searchParams.delete(key);
  url.searchParams.delete('page');
  if (nextValues.length) url.searchParams.set(key, nextValues.join(','));

  window.history.pushState({}, '', url);
  syncKultaClientTypeFilters();
}

function clearKultaClientFilters(form) {
  const url = new URL(window.location.href);
  getKultaClientFilterGroups(form).forEach((group) => {
    url.searchParams.delete(group);
  });
  url.searchParams.delete('page');
  window.history.pushState({}, '', url);
  syncKultaClientTypeFilters();
}

function kultaClientFilterMatches(card, group, values) {
  if (!values.length) return true;

  if (group === 'availability') {
    const availability = card.dataset.productAvailable === 'true' ? '1' : '0';
    return values.includes(availability);
  }

  const tagString = String(card.dataset.productTags || '');
  const matchValues = group === 'product_type'
    ? values.flatMap((value) => KULTA_PRODUCT_TYPE_FILTER_ALIASES[value] || [value])
    : values;

  return matchValues.some((value) => tagString.includes(`|${value}|`));
}

function syncKultaClientTypeFilters() {
  document.querySelectorAll('[data-kulta-client-filters]').forEach((form) => {
    const shell = form.closest('.kulta-collection-shell');
    const grid = shell?.querySelector('[data-kulta-product-grid]');
    const state = getKultaClientFilterState(form);
    const activeGroups = Object.entries(state).filter(([, values]) => values.length > 0);
    const optionLabels = new Map();

    form.querySelectorAll('[data-kulta-client-filter-option]').forEach((option) => {
      const group = normalizeKultaClientFilterGroup(option.dataset.kultaClientFilterGroup);
      const value = normalizeKultaClientFilterValue(option.dataset.kultaClientFilterOption);
      const label = option.dataset.kultaClientFilterLabel || option.textContent.trim();
      if (group && value) optionLabels.set(`${group}:${value}`, label);
      option.classList.toggle('is-active', Boolean(state[group]?.includes(value)));
    });

    form.querySelectorAll('[data-kulta-client-availability-input]').forEach((input) => {
      const value = normalizeKultaClientFilterValue(input.dataset.kultaClientAvailabilityInput || input.value);
      const label = input.closest('[data-kulta-client-availability-option]')?.dataset.kultaClientFilterLabel || input.closest('label')?.textContent.trim() || value;
      if (value) optionLabels.set(`availability:${value}`, label);
      input.checked = Boolean(state.availability?.includes(value));
      input.closest('.kulta-filter-option')?.classList.toggle('is-active', input.checked);
    });

    if (grid) {
      /* Creative square layouts pin cards to fixed grid cells; when a client
         filter hides cards those cells become holes. Mark the grid so the CSS
         falls back to auto-flow while any client filter is active. */
      grid.classList.toggle('is-kulta-filtered', activeGroups.length > 0);
      let visibleCount = 0;
      grid.querySelectorAll('[data-kulta-product-card]').forEach((card) => {
        const matches = activeGroups.every(([group, values]) => kultaClientFilterMatches(card, group, values));
        card.hidden = !matches;
        card.classList.toggle('is-kulta-filter-hidden', !matches);
        if (matches) visibleCount += 1;
      });

      const countLabel = shell.querySelector('[data-kulta-collection-count]');
      if (countLabel) {
        const totalCount = Number(countLabel.dataset.kultaCollectionTotal) || visibleCount;
        const count = activeGroups.length ? visibleCount : totalCount;
        countLabel.textContent = `${count} ${count === 1 ? 'piece' : 'pieces'}`;
      }
    }

    const chips = form.querySelector('[data-kulta-client-filter-chips], [data-kulta-client-type-chips]');
    if (!chips) return;

    chips.replaceChildren();
    chips.hidden = activeGroups.length === 0;

    activeGroups.forEach(([group, values]) => {
      values.forEach((value) => {
        const chip = document.createElement('a');
        const close = document.createElement('span');
        chip.href = '#';
        chip.className = 'kulta-active-filter';
        chip.dataset.kultaClientFilterRemove = value;
        chip.dataset.kultaClientFilterGroup = group;
        chip.append(document.createTextNode(`${optionLabels.get(`${group}:${value}`) || value} `));
        close.textContent = 'x';
        chip.append(close);
        chips.append(chip);
      });
    });

    if (activeGroups.length) {
      const clear = document.createElement('a');
      clear.href = '#';
      clear.className = 'kulta-clear-filters';
      clear.dataset.kultaClientFilterClear = 'true';
      clear.textContent = 'Clear all';
      chips.append(clear);
    }
  });
}

function initKultaClientTypeFilters(root) {
  root.querySelectorAll('[data-kulta-client-filter-link]').forEach((link) => {
    if (link.dataset.kultaClientFilterReady) return;
    link.dataset.kultaClientFilterReady = 'true';

    link.addEventListener('click', (event) => {
      const form = link.closest('[data-kulta-client-filters]');
      const group = normalizeKultaClientFilterGroup(link.dataset.kultaClientFilterGroup);
      const value = normalizeKultaClientFilterValue(link.dataset.kultaClientFilterLink);
      if (!form || !group || !value) return;

      event.preventDefault();
      const values = getKultaClientFilterValues(form, group);
      const nextValues = values.includes(value)
        ? values.filter((item) => item !== value)
        : [...values, value];
      setKultaClientFilterValues(form, group, nextValues);
    });
  });

  root.querySelectorAll('[data-kulta-client-availability-input]').forEach((input) => {
    if (input.dataset.kultaClientAvailabilityReady) return;
    input.dataset.kultaClientAvailabilityReady = 'true';

    input.addEventListener('change', () => {
      const form = input.closest('[data-kulta-client-filters]');
      const value = normalizeKultaClientFilterValue(input.dataset.kultaClientAvailabilityInput || input.value);
      if (!form || !value) return;

      const values = getKultaClientFilterValues(form, 'availability');
      const nextValues = input.checked
        ? [...values, value]
        : values.filter((item) => item !== value);
      setKultaClientFilterValues(form, 'availability', nextValues);
    });
  });

  root.querySelectorAll('[data-kulta-client-filter-chips], [data-kulta-client-type-chips]').forEach((chips) => {
    if (chips.dataset.kultaClientFilterChipsReady) return;
    chips.dataset.kultaClientFilterChipsReady = 'true';

    chips.addEventListener('click', (event) => {
      const control = event.target.closest('[data-kulta-client-filter-remove], [data-kulta-client-filter-clear]');
      const form = control?.closest('[data-kulta-client-filters]');
      if (!control || !form) return;

      event.preventDefault();
      if (control.dataset.kultaClientFilterClear) {
        clearKultaClientFilters(form);
        return;
      }

      const group = normalizeKultaClientFilterGroup(control.dataset.kultaClientFilterGroup);
      const removeValue = normalizeKultaClientFilterValue(control.dataset.kultaClientFilterRemove);
      const nextValues = getKultaClientFilterValues(form, group).filter((value) => value !== removeValue);
      setKultaClientFilterValues(form, group, nextValues);
    });
  });

  if (!document.documentElement.dataset.kultaClientFilterPopstateReady) {
    document.documentElement.dataset.kultaClientFilterPopstateReady = 'true';
    window.addEventListener('popstate', syncKultaClientTypeFilters);
  }

  syncKultaClientTypeFilters();
}

// Keep the current photo visible until its replacement is loaded and decoded.
function waitForKultaImage(image) {
  if (!image) return Promise.resolve(true);
  return new Promise((resolve) => {
    let settled = false;
    const finish = (ok) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      image.removeEventListener('load', loaded);
      image.removeEventListener('error', failed);
      resolve(ok);
    };
    const loaded = () => {
      if (!image.naturalWidth) return finish(false);
      if (image.decode) image.decode().then(() => finish(true), () => finish(image.naturalWidth > 0));
      else finish(true);
    };
    const failed = () => finish(false);
    const timer = window.setTimeout(failed, 15000);
    image.addEventListener('load', loaded, { once: true });
    image.addEventListener('error', failed, { once: true });
    if (image.complete) loaded();
  });
}

function kultaCanPreloadImage() {
  const connection = navigator.connection;
  return !connection || (!connection.saveData && !/^(slow-)?2g$/.test(connection.effectiveType));
}

function initKultaTheme(root) {
  const header = document.getElementById('header');
  if (header && !header.dataset.kultaScrollReady) {
    header.dataset.kultaScrollReady = 'true';
    const updateHeader = () => {
      header.classList.toggle('scrolled', window.scrollY > 50);
    };
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    const heroLike = document.querySelector('.hero, .kulta-collection-hero, .kulta-collection-heading-band--photo');
    if (heroLike) {
      const heroObserver = new IntersectionObserver(([entry]) => {
        header.classList.toggle('over-hero', entry.isIntersecting);
      }, { threshold: 0.08 });
      heroObserver.observe(heroLike);
    }
  }

  root.querySelectorAll('.hero').forEach((hero) => {
    if (hero.dataset.kultaCarouselReady) return;
    hero.dataset.kultaCarouselReady = 'true';

    const slides = hero.querySelectorAll('.hero-slide');
    const dots = hero.querySelectorAll('.hero-dot');
    const prev = hero.querySelector('[data-hero-prev], .hero-arrow-prev, #heroPrev');
    const next = hero.querySelector('[data-hero-next], .hero-arrow-next, #heroNext');
    const toggle = hero.querySelector('[data-hero-toggle]');
    const slidesRegion = hero.querySelector('.hero-slides');
    const activeIndex = Array.from(slides).findIndex((slide) => slide.classList.contains('active'));
    let currentSlide = activeIndex >= 0 ? activeIndex : 0;
    let slideInterval;
    let touchStartX = 0;
    let touchStartY = 0;
    const slideIntervalTime = Number.parseInt(hero.dataset.autoplaySpeed, 10) || 6000;
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let userPaused = hero.dataset.autoplay === 'false' || reduceMotion;

    if (slides.length < 1) return;

    function updateA11y() {
      slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index === currentSlide ? 'false' : 'true');
      });
      dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === currentSlide ? 'true' : 'false');
      });
      if (slidesRegion) slidesRegion.setAttribute('aria-live', userPaused ? 'polite' : 'off');
    }

    function updateToggle() {
      if (!toggle) return;
      const paused = userPaused || reduceMotion;
      hero.classList.toggle('is-carousel-paused', paused);
      toggle.classList.toggle('is-paused', paused);
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
    }

    let slideRequest = 0;
    function prepareNextSlide() {
      if (!kultaCanPreloadImage() || slides.length < 2) return;
      const image = slides[(currentSlide + 1) % slides.length].querySelector('img');
      if (image) image.loading = 'eager';
    }

    async function goToSlide(index) {
      const request = ++slideRequest;
      const nextIndex = (index + slides.length) % slides.length;
      if (nextIndex === currentSlide) return;
      const image = slides[nextIndex].querySelector('img');
      if (image) image.loading = 'eager';
      const ready = await waitForKultaImage(image);
      if (!ready || request !== slideRequest || !hero.isConnected) return;

      slides[currentSlide].classList.remove('active');
      if (dots[currentSlide]) dots[currentSlide].classList.remove('active');
      currentSlide = nextIndex;
      slides[currentSlide].classList.add('active');
      if (dots[currentSlide]) dots[currentSlide].classList.add('active');
      updateA11y();
      prepareNextSlide();
    }

    function nextSlide() {
      goToSlide((currentSlide + 1) % slides.length);
    }

    function startCarousel() {
      window.clearInterval(slideInterval); // idempotent: never leave a duplicate auto-advance interval running
      if (reduceMotion || userPaused) return;
      if (slides.length > 1) slideInterval = window.setInterval(nextSlide, slideIntervalTime);
    }

    function stopCarousel() {
      window.clearInterval(slideInterval);
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        stopCarousel();
        goToSlide(index);
        startCarousel();
      });
    });

    if (prev) {
      prev.addEventListener('click', () => {
        stopCarousel();
        goToSlide(currentSlide - 1);
        startCarousel();
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        stopCarousel();
        nextSlide();
        startCarousel();
      });
    }

    if (toggle) {
      toggle.addEventListener('click', () => {
        if (reduceMotion) return;
        userPaused = !userPaused;
        if (userPaused) {
          slideRequest += 1;
          stopCarousel();
        }
        else startCarousel();
        updateA11y();
        updateToggle();
      });
    }

    hero.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        stopCarousel();
        goToSlide(currentSlide - 1);
        startCarousel();
      } else if (event.key === 'ArrowRight') {
        stopCarousel();
        nextSlide();
        startCarousel();
      }
    });

    hero.addEventListener('mouseenter', stopCarousel);
    hero.addEventListener('mouseleave', startCarousel);
    hero.addEventListener('focusin', stopCarousel);
    hero.addEventListener('focusout', startCarousel);

    hero.addEventListener('touchstart', (event) => {
      const touch = event.changedTouches[0];
      if (!touch) return;
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      stopCarousel();
    }, { passive: true });

    hero.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (!touch) return;
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      if (Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
        goToSlide(currentSlide + (deltaX < 0 ? 1 : -1));
      }
      startCarousel();
    }, { passive: true });

    hero.addEventListener('touchcancel', startCarousel, { passive: true });

    updateA11y();
    updateToggle();
    startCarousel();
    waitForKultaImage(slides[currentSlide].querySelector('img')).then((ready) => {
      if (ready && hero.isConnected) prepareNextSlide();
    });
  });

  root.querySelectorAll('[data-kulta-auto-submit]').forEach((field) => {
    if (field.dataset.kultaSubmitReady) return;
    field.dataset.kultaSubmitReady = 'true';
    field.addEventListener('change', () => {
      const form = field.closest('form');
      if (form) kultaAjaxFilter(form);
    });
  });

  root.querySelectorAll('form.kulta-filter-form').forEach((form) => {
    if (form.dataset.kultaAjaxFilterReady) return;
    form.dataset.kultaAjaxFilterReady = 'true';
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      kultaAjaxFilter(form);
    });
  });

  initKultaClientTypeFilters(root);

  root.querySelectorAll('[data-kulta-view]').forEach((button) => {
    if (button.dataset.kultaViewReady) return;
    button.dataset.kultaViewReady = 'true';
    button.addEventListener('click', () => {
      const grid = button.closest('.kulta-collection-shell')?.querySelector('[data-kulta-product-grid]');
      if (!grid) return;

      const mode = button.dataset.kultaView;
      grid.classList.toggle('is-dense', mode === 'dense');
      button.parentElement.querySelectorAll('[data-kulta-view]').forEach((sibling) => {
        sibling.classList.toggle('is-active', sibling === button);
      });
    });
  });

  root.querySelectorAll('[data-kulta-load-more]').forEach((button) => {
    if (button.dataset.kultaLoadMoreReady) return;
    button.dataset.kultaLoadMoreReady = 'true';

    button.addEventListener('click', async () => {
      const scope = button.closest('.kulta-collection-shell, .kulta-search-results-panel') || document;
      const grid = scope.querySelector('[data-kulta-product-grid]');
      const wrapper = button.closest('[data-kulta-load-more-wrap]');
      const originalText = button.textContent;
      const nextUrl = button.dataset.nextUrl;

      if (!grid || !nextUrl) return;

      button.disabled = true;
      button.textContent = 'Loading';

      try {
        await withKultaLoader(async () => {
          const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('Unable to load more products');

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextGrid = doc.querySelector('[data-kulta-product-grid]');
          const nextCards = nextGrid ? nextGrid.querySelectorAll('[data-kulta-product-card]') : [];

          nextCards.forEach((card) => {
            grid.appendChild(document.importNode(card, true));
          });

          initKultaTheme(grid);
          syncKultaClientTypeFilters();

          const nextButton = doc.querySelector('[data-kulta-load-more]');
          if (nextButton?.dataset.nextUrl) {
            button.dataset.nextUrl = nextButton.dataset.nextUrl;
            button.dataset.currentPage = nextButton.dataset.currentPage;
            button.dataset.totalPages = nextButton.dataset.totalPages;
            button.disabled = false;
            button.textContent = originalText;
          } else if (wrapper) {
            wrapper.remove();
          }
        });
      } catch (error) {
        button.disabled = false;
        button.textContent = 'Try again';
      }
    });
  });

  root.querySelectorAll('[data-kulta-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.kultaGalleryReady) return;
    gallery.dataset.kultaGalleryReady = 'true';

    const mainImage = gallery.querySelector('[data-kulta-main-image]');
    const thumbs = gallery.querySelectorAll('[data-kulta-product-thumb]');
    if (!mainImage || thumbs.length < 1) return;

    let selectionRequest = 0;
    const prepared = new Map();
    const sourceFor = (thumb) => ({
      src: thumb.dataset.previewSrc,
      srcset: thumb.dataset.previewSrcset || '',
      alt: thumb.dataset.previewAlt || mainImage.alt,
    });
    const prepare = (source) => {
      const key = source.src + '|' + source.srcset;
      if (!prepared.has(key)) {
        const image = new Image();
        image.sizes = mainImage.sizes;
        if (source.srcset) image.srcset = source.srcset;
        image.src = source.src;
        const ready = waitForKultaImage(image).then((ok) => {
          if (!ok) prepared.delete(key);
          return ok;
        });
        prepared.set(key, ready);
      }
      return prepared.get(key);
    };
    const status = document.createElement('p');
    status.className = 'kulta-gallery-status';
    status.setAttribute('role', 'status');
    gallery.appendChild(status);
    const preloadNext = () => {
      if (!kultaCanPreloadImage()) return;
      const active = Array.from(thumbs).findIndex(thumb => thumb.classList.contains('is-active'));
      const next = thumbs[active + 1];
      if (next) prepare(sourceFor(next));
    };

    gallery.kultaSelectImage = async (source, thumb) => {
      const request = ++selectionRequest;
      if (!source.src) return;
      status.textContent = '';
      gallery.setAttribute('aria-busy', 'true');
      const ready = await prepare(source);
      if (request !== selectionRequest || !gallery.isConnected) return;
      gallery.removeAttribute('aria-busy');
      if (!ready) {
        status.textContent = "This photo couldn't load. Please try again.";
        return;
      }
      if (source.srcset) mainImage.srcset = source.srcset;
      else mainImage.removeAttribute('srcset');
      mainImage.src = source.src;
      mainImage.alt = source.alt;
      thumbs.forEach((sibling) => sibling.classList.toggle('is-active', sibling === thumb));
      preloadNext();
    };
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        // Selecting the current image also cancels a slower pending selection.
        gallery.kultaSelectImage(sourceFor(thumb), thumb);
      });
    });
    waitForKultaImage(mainImage).then((ready) => {
      if (ready && gallery.isConnected) preloadNext();
    });
  });

  root.querySelectorAll('.kulta-quantity-control').forEach((control) => {
    if (control.dataset.kultaQuantityReady) return;
    control.dataset.kultaQuantityReady = 'true';

    const input = control.querySelector('input[name="quantity"]');
    const minus = control.querySelector('[data-kulta-qty-minus]');
    const plus = control.querySelector('[data-kulta-qty-plus]');
    if (!input) return;

    const clampQuantity = (value) => {
      const min = Number(input.min || 1);
      const parsed = Number.parseInt(value, 10);
      if (Number.isNaN(parsed)) return min;
      return Math.max(min, parsed);
    };

    if (minus) {
      minus.addEventListener('click', () => {
        input.value = clampQuantity(Number(input.value || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (plus) {
      plus.addEventListener('click', () => {
        input.value = clampQuantity(Number(input.value || 1) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    input.addEventListener('change', () => {
      input.value = clampQuantity(input.value);
    });
  });

  root.querySelectorAll('[data-kulta-variant-radio]').forEach((radio) => {
    if (radio.dataset.kultaVariantReady) return;
    radio.dataset.kultaVariantReady = 'true';

    radio.addEventListener('change', () => {
      const form = radio.closest('.kulta-product-form');
      const page = radio.closest('.kulta-product-page');
      if (!form || !page) return;

      const variantId = Number(radio.value);
      const dataEl = page.querySelector('[data-kulta-product-json]') || document.querySelector('[data-kulta-product-json]');
      if (!dataEl) return;

      let variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      const variant = variants.find((v) => v.id === variantId);
      if (!variant) return;

      const priceRow = page.querySelector('.kulta-product-price-row');
      if (priceRow) {
        if (!variant.available) {
          priceRow.innerHTML = `<span class="kulta-product-price is-muted">${escapeKultaHtml(variant.price_formatted)}</span><span class="kulta-product-stock-badge">Out of stock</span>`;
        } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceRow.innerHTML = `<span class="kulta-product-compare-price">${escapeKultaHtml(variant.compare_at_price_formatted)}</span><span class="kulta-product-sale-price">${escapeKultaHtml(variant.price_formatted)}</span>`;
        } else {
          priceRow.innerHTML = `<span class="kulta-product-price">${escapeKultaHtml(variant.price_formatted)}</span>`;
        }
      }

      const addBtn = form.querySelector('.kulta-product-add');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to bag' : 'Out of stock';
      }

      if (variant.featured_image) {
        const gallery = page.querySelector('[data-kulta-product-gallery]');
        if (gallery?.kultaSelectImage) {
          const thumb = Array.from(gallery.querySelectorAll('[data-kulta-product-thumb]'))
            .find((item) => item.dataset.previewSrc === variant.featured_image);
          gallery.kultaSelectImage({
            src: variant.featured_image,
            srcset: variant.featured_srcset || '',
            alt: variant.featured_alt || '',
          }, thumb);
        }
      }

      const variantUrl = new URL(window.location);
      variantUrl.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', variantUrl);
    });
  });

  initKultaMobileMenu();
  initKultaRecentProducts(root);
  initKultaPredictiveSearch(root);
  initKultaFavorites(root);
  initKultaRecommendedPage(root);
  initKultaProductRecommendations(root);
  initKultaAjaxCart(root);
}

function initKultaMobileMenu() {
  const drawer = document.getElementById('kulta-mobile-drawer');
  const overlay = document.getElementById('kulta-mobile-overlay');
  if (!drawer || drawer.dataset.kultaMobileReady) return;
  drawer.dataset.kultaMobileReady = 'true';
  drawer.setAttribute('inert', '');
  const toggles = Array.from(document.querySelectorAll('[data-kulta-mobile-toggle]'));
  const focusableSelector = 'a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let lastFocused = null;

  function drawerFocusables() {
    return Array.from(drawer.querySelectorAll(focusableSelector)).filter((element) => {
      return !element.closest('[hidden]') && element.getClientRects().length > 0;
    });
  }

  function openDrawer(event) {
    lastFocused = event?.currentTarget || document.activeElement;
    drawer.removeAttribute('inert');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    window.requestAnimationFrame(() => drawerFocusables()[0]?.focus());
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocused?.isConnected) lastFocused.focus();
  }

  toggles.forEach((btn) => {
    btn.setAttribute('aria-controls', drawer.id);
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', openDrawer);
  });

  document.querySelectorAll('[data-kulta-mobile-close]').forEach((btn) => {
    btn.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (!drawer.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusables = drawerFocusables();
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
}

function initKultaPredictiveSearch(root) {
  const searchFields = 'title,product_type,tag,variants.title,vendor';

  root.querySelectorAll('[data-kulta-predictive-search]').forEach((form) => {
    if (form.dataset.kultaPredictiveReady) return;
    form.dataset.kultaPredictiveReady = 'true';

    const input = form.querySelector('[data-kulta-predictive-input]');
    const results = form.querySelector('[data-kulta-predictive-results]');
    if (!input || !results) return;

    if (!results.id) results.id = `KultaPredictiveResults-${Math.random().toString(36).slice(2, 9)}`;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-controls', results.id);
    results.setAttribute('role', 'listbox');
    if (!results.hasAttribute('aria-label')) results.setAttribute('aria-label', 'Search suggestions');

    let timer;
    let controller;
    let latestQuery = '';

    const prepareResultOptions = () => {
      results.querySelectorAll('.kulta-predictive-item, .kulta-predictive-view-all').forEach((option, index) => {
        option.id = `${results.id}-option-${index}`;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
      });
    };

    const closeResults = () => {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      results.querySelectorAll('[role="option"]').forEach((option) => {
        option.classList.remove('kulta-predictive-active');
        option.setAttribute('aria-selected', 'false');
      });
    };

    const openResults = () => {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const renderResults = (query, products) => {
      if (query !== latestQuery) return;

      const encodedFields = encodeURIComponent(searchFields);
      const searchUrl = `/search?type=product&options%5Bprefix%5D=last&options%5Bfields%5D=${encodedFields}&q=${encodeURIComponent(query)}`;
      if (!products.length) {
        results.innerHTML = `<span class="kulta-predictive-empty">No quick matches</span><a class="kulta-predictive-view-all" href="${escapeKultaAttribute(searchUrl)}">Search all pieces</a>`;
        prepareResultOptions();
        openResults();
        return;
      }

      const items = products.map((product) => {
        const title = product.title || product.handle || '';
        const url = product.url || `/products/${product.handle || ''}`;
        const image = getPredictiveProductImage(product);
        const price = getPredictiveProductPrice(product);
        const imageMarkup = image
          ? `<img src="${escapeKultaAttribute(image)}" srcset="${escapeKultaAttribute(kultaImageSrcset(image))}" sizes="56px" width="120" height="120" decoding="async" alt="${escapeKultaAttribute(title)}" loading="lazy">`
          : '<span class="kulta-predictive-placeholder">Image</span>';

        return `<a class="kulta-predictive-item" href="${escapeKultaAttribute(url)}">
          <span class="kulta-predictive-image">${imageMarkup}</span>
          <span class="kulta-predictive-copy">
            <strong>${escapeKultaHtml(title)}</strong>
            <span>${escapeKultaHtml(price)}</span>
          </span>
        </a>`;
      }).join('');

      results.innerHTML = `<div class="kulta-predictive-list">${items}</div><a class="kulta-predictive-view-all" href="${escapeKultaAttribute(searchUrl)}">View all results</a>`;
      prepareResultOptions();
      openResults();
    };

    const fetchResults = async (query) => {
      if (controller) controller.abort();
      controller = new AbortController();
      latestQuery = query;

      const encodedFields = encodeURIComponent(searchFields);
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=${encodedFields}`;

      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Predictive search failed');

        const data = await response.json();
        const products = data?.resources?.results?.products || [];
        renderResults(query, products);
      } catch (error) {
        if (error.name !== 'AbortError') closeResults();
      }
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();
      window.clearTimeout(timer);

      if (query.length < 2) {
        latestQuery = query;
        closeResults();
        return;
      }

      timer = window.setTimeout(() => fetchResults(query), 180);
    });

    input.addEventListener('focus', () => {
      if (results.innerHTML.trim() !== '' && input.value.trim().length >= 2) openResults();
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeResults();
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) closeResults();
    });

    initKultaSearchKeyboard(form);
  });
}

function getPredictiveProductImage(product) {
  const image = product.featured_image || product.image;
  if (!image) return '';
  if (typeof image === 'string') return image;
  return image.url || image.src || '';
}

function getPredictiveProductPrice(product) {
  const rawPrice = product.price || product.price_min || product.price_varies_min || product.variants?.[0]?.price;
  if (!rawPrice) return '';
  if (typeof rawPrice === 'number') return formatKultaMoney(rawPrice);
  const amount = parseFloat(String(rawPrice).replace(/[^0-9.]/g, ''));
  return Number.isNaN(amount) ? String(rawPrice) : formatKultaMoney(Math.round(amount * 100));
}

function readKultaFavorites() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(KULTA_FAVORITES_KEY) || '[]');
    return Array.isArray(parsed) ? parsed.filter((item) => item && item.handle) : [];
  } catch (error) {
    return [];
  }
}

function writeKultaFavorites(items) {
  try {
    window.localStorage.setItem(KULTA_FAVORITES_KEY, JSON.stringify(items));
  } catch (error) {
    // localStorage may be unavailable in private browsing
  }
}

function getFavoritePayload(button) {
  return {
    id: button.dataset.productId,
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    price: button.dataset.productPrice,
    image: button.dataset.productImage,
  };
}

function updateFavoriteButtons(scope = document) {
  const savedHandles = new Set(readKultaFavorites().map((item) => item.handle));
  scope.querySelectorAll('[data-kulta-favorite-toggle]').forEach((button) => {
    const isSaved = savedHandles.has(button.dataset.productHandle);
    button.classList.toggle('is-active', isSaved);
    button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    const productTitle = button.dataset.productTitle || 'piece';
    button.setAttribute('aria-label', isSaved ? `Remove ${productTitle} from favorites` : `Save ${productTitle} to favorites`);

    const label = button.querySelector('span');
    if (label) label.textContent = isSaved ? 'Saved to favorites' : 'Save to favorites';
  });
}

function toggleKultaFavorite(payload) {
  if (!payload.handle) return;

  const favorites = readKultaFavorites();
  const existingIndex = favorites.findIndex((item) => item.handle === payload.handle);
  let isSaved = true;

  if (existingIndex >= 0) {
    favorites.splice(existingIndex, 1);
    isSaved = false;
  } else {
    favorites.unshift(payload);
  }

  writeKultaFavorites(favorites);
  return isSaved;
}

function showKultaToast(message) {
  let toast = document.querySelector('[data-kulta-toast]');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'kulta-toast';
    toast.setAttribute('data-kulta-toast', '');
    document.body.appendChild(toast);
  }

  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.setAttribute('aria-atomic', 'true');

  toast.textContent = message;
  toast.classList.add('is-visible');
  window.clearTimeout(showKultaToast.timeoutId);
  showKultaToast.timeoutId = window.setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 1800);
}

function formatKultaMoney(cents) {
  const currency = window.Shopify?.currency?.active || 'USD';
  const amount = Number(cents || 0) / 100;

  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
    }).format(amount);
  } catch (error) {
    return `$${amount.toFixed(2)}`;
  }
}

function getKultaImageUrl(image) {
  if (!image) return '';
  if (typeof image === 'string') return image;
  return image.url || image.src || image.preview_image?.src || '';
}

function kultaCdnWidth(url, w) {
  if (!url) return url;
  try { const u = new URL(url, window.location.href); u.searchParams.set('width', w); return u.href; } catch (e) { return url; }
}

function kultaImageSrcset(url) {
  if (!url) return '';
  return [300, 450, 600, 800].map((w) => `${kultaCdnWidth(url, w)} ${w}w`).join(', ');
}

function getKultaSecondaryImage(images, primaryUrl) {
  if (!Array.isArray(images)) return '';

  const primary = String(primaryUrl || '');
  const match = images
    .map(getKultaImageUrl)
    .find((imageUrl) => imageUrl && imageUrl !== primary);

  return match || '';
}

function getKultaProductVariant(product) {
  const variants = Array.isArray(product?.variants) ? product.variants : [];
  return variants.find((variant) => variant.available) || variants[0] || {};
}

function kultaQuickAddMarkup(item, title, className = 'kulta-quick-add') {
  const variantId = item.variantId || item.variant_id;
  if (!variantId || item.available === false) return '';

  return `<form method="post" action="/cart/add" class="${className}-form">
    <input type="hidden" name="id" value="${escapeKultaAttribute(variantId)}">
    <button type="submit" class="${className}" aria-label="Add ${escapeKultaAttribute(title)} to bag">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.45" aria-hidden="true">
        <path d="M6.5 7.5h11l-1 12h-9z"></path>
        <path d="M9 7.5a3 3 0 0 1 6 0"></path>
      </svg>
      <span>Add</span>
    </button>
  </form>`;
}

function kultaCardImageMarkup(item, title) {
  if (!item.image) {
    return '<div class="kulta-product-placeholder"><span>Product image</span></div>';
  }

  const secondary = item.secondaryImage
    ? `<img src="${escapeKultaAttribute(item.secondaryImage)}" srcset="${escapeKultaAttribute(kultaImageSrcset(item.secondaryImage))}" sizes="(max-width:768px) 48vw, 22vw" width="600" height="600" decoding="async" alt="${escapeKultaAttribute(title)}" class="kulta-product-image kulta-product-image--secondary" loading="lazy">`
    : '';

  return `<img src="${escapeKultaAttribute(item.image)}" srcset="${escapeKultaAttribute(kultaImageSrcset(item.image))}" sizes="(max-width:768px) 48vw, 22vw" width="600" height="600" decoding="async" alt="${escapeKultaAttribute(title)}" class="kulta-product-image kulta-product-image--primary" loading="lazy">${secondary}`;
}

async function hydrateFavoriteProduct(favorite) {
  try {
    const response = await fetch(`/products/${favorite.handle}.js`);
    if (!response.ok) return favorite;

    const product = await response.json();
    const variant = getKultaProductVariant(product);
    const image = product.featured_image || product.images?.[0] || favorite.image;

    return {
      id: product.id || favorite.id,
      handle: product.handle || favorite.handle,
      title: product.title || favorite.title,
      url: product.url || `/products/${product.handle || favorite.handle}`,
      price: product.price ? formatKultaMoney(product.price) : favorite.price,
      image,
      secondaryImage: getKultaSecondaryImage(product.images, image),
      variantId: variant.id || favorite.variantId,
      available: product.available !== false && variant.available !== false,
    };
  } catch (error) {
    return favorite;
  }
}

function favoriteCardMarkup(item) {
  const title = item.title || item.handle;
  const url = item.url || `/products/${item.handle}`;
  const price = item.price || '';
  const imageMarkup = kultaCardImageMarkup(item, title);

  return `<article class="kulta-collection-card kulta-favorite-card" data-kulta-product-card data-product-id="${escapeKultaAttribute(item.id || '')}" data-product-handle="${escapeKultaAttribute(item.handle || '')}" data-product-title="${escapeKultaAttribute(title)}" data-product-url="${escapeKultaAttribute(url)}" data-product-price="${escapeKultaAttribute(price)}" data-product-image="${escapeKultaAttribute(item.image || '')}">
    <div class="kulta-product-image-wrap img-scale-wrap">
      <a href="${escapeKultaAttribute(url)}" class="kulta-product-image-link" aria-label="${escapeKultaAttribute(title)}">
        ${imageMarkup}
      </a>
      <button
        type="button"
        class="kulta-product-heart is-active"
        data-kulta-favorite-toggle
        data-product-id="${escapeKultaAttribute(item.id || '')}"
        data-product-handle="${escapeKultaAttribute(item.handle)}"
        data-product-title="${escapeKultaAttribute(title)}"
        data-product-url="${escapeKultaAttribute(url)}"
        data-product-price="${escapeKultaAttribute(price)}"
        data-product-image="${escapeKultaAttribute(item.image || '')}"
        aria-label="Remove ${escapeKultaAttribute(title)} from favorites"
        aria-pressed="true"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l7.78-7.78a5.5 5.5 0 0 0 1.06-8.84z"></path></svg>
      </button>
      ${kultaQuickAddMarkup(item, title)}
    </div>
    <a href="${escapeKultaAttribute(url)}" class="kulta-product-link" aria-label="${escapeKultaAttribute(title)}">
      <div class="kulta-product-info">
        <h3 class="kulta-product-title">${escapeKultaHtml(title)}</h3>
        <span class="kulta-product-price">${escapeKultaHtml(price)}</span>
      </div>
    </a>
  </article>`;
}

async function renderKultaFavoritesPage(page) {
  const grid = page.querySelector('[data-kulta-favorites-grid]');
  const empty = page.querySelector('[data-kulta-favorites-empty]');
  if (!grid || !empty) return;

  const favorites = readKultaFavorites();
  const hasFavorites = favorites.length > 0;

  empty.hidden = hasFavorites;
  grid.hidden = !hasFavorites;

  if (!hasFavorites) {
    grid.innerHTML = '';
    return;
  }

  grid.innerHTML = '<div class="kulta-favorites-loading">Loading favorites</div>';
  const hydrated = await withKultaLoader(() => Promise.all(favorites.map(hydrateFavoriteProduct)));
  grid.innerHTML = hydrated.map(favoriteCardMarkup).join('');
  initKultaTheme(grid);
  updateFavoriteButtons(grid);
}

function initKultaFavorites(root) {
  root.querySelectorAll('[data-kulta-favorite-toggle]').forEach((button) => {
    if (button.dataset.kultaFavoriteReady) return;
    button.dataset.kultaFavoriteReady = 'true';

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isSaved = toggleKultaFavorite(getFavoritePayload(button));
      updateFavoriteButtons(document);
      showKultaToast(isSaved ? 'Added to favorites' : 'Removed from favorites');

      document.querySelectorAll('[data-kulta-favorites-page]').forEach((page) => {
        renderKultaFavoritesPage(page);
      });

      document.querySelectorAll('[data-kulta-recommended-page]').forEach((page) => {
        renderKultaRecommendedPage(page);
      });
    });
  });

  updateFavoriteButtons(root);

  if (!document.documentElement.dataset.kultaFavoriteA11ySyncReady) {
    document.documentElement.dataset.kultaFavoriteA11ySyncReady = 'true';
    const favoriteObserver = new MutationObserver((mutations) => {
      const hasNewFavorite = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => {
        return node.nodeType === 1 && (node.matches?.('[data-kulta-favorite-toggle]') || node.querySelector?.('[data-kulta-favorite-toggle]'));
      }));
      if (hasNewFavorite) updateFavoriteButtons(document);
    });
    favoriteObserver.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', (event) => {
      if (!event.target.closest?.('[data-kulta-favorite-toggle]')) return;
      window.setTimeout(() => updateFavoriteButtons(document), 0);
    });
  }
  root.querySelectorAll('[data-kulta-favorites-page]').forEach((page) => {
    renderKultaFavoritesPage(page);
  });
}

function readKultaRecentProducts() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(KULTA_RECENT_PRODUCTS_KEY) || '[]');
    return Array.isArray(parsed) ? parsed.filter((item) => item && item.handle) : [];
  } catch (error) {
    return [];
  }
}

function writeKultaRecentProducts(items) {
  try {
    window.localStorage.setItem(KULTA_RECENT_PRODUCTS_KEY, JSON.stringify(items));
  } catch (error) {
    // localStorage may be unavailable in private browsing
  }
}

function getKultaProductPayload(element) {
  if (!element) return {};

  return {
    id: element.dataset.productId,
    handle: element.dataset.productHandle,
    title: element.dataset.productTitle,
    url: element.dataset.productUrl,
    price: element.dataset.productPrice,
    image: element.dataset.productImage,
    image2: element.dataset.productImage2,
    viewedAt: Date.now(),
  };
}

function recordKultaRecentProduct(payload) {
  if (!payload.handle) return;

  const recent = readKultaRecentProducts().filter((item) => item.handle !== payload.handle);
  recent.unshift(payload);
  writeKultaRecentProducts(recent.slice(0, 14));
}

function initKultaRecentProducts(root) {
  root.querySelectorAll('[data-kulta-product-view]').forEach((view) => {
    if (view.dataset.kultaRecentReady) return;
    view.dataset.kultaRecentReady = 'true';
    recordKultaRecentProduct(getKultaProductPayload(view));
  });
}

function recommendationCardMarkup(item) {
  const normalized = normalizeRecommendedProduct(item);
  const title = normalized.title || normalized.handle;
  const url = normalized.url || `/products/${normalized.handle}`;
  const price = normalized.price || '';
  const imageMarkup = kultaCardImageMarkup(normalized, title);

  return `<article class="kulta-collection-card" data-kulta-product-card data-product-id="${escapeKultaAttribute(normalized.id || '')}" data-product-handle="${escapeKultaAttribute(normalized.handle || '')}" data-product-title="${escapeKultaAttribute(title)}" data-product-url="${escapeKultaAttribute(url)}" data-product-price="${escapeKultaAttribute(price)}" data-product-image="${escapeKultaAttribute(normalized.image || '')}">
    <div class="kulta-product-image-wrap img-scale-wrap">
      <a href="${escapeKultaAttribute(url)}" class="kulta-product-image-link" aria-label="${escapeKultaAttribute(title)}">
        ${imageMarkup}
      </a>
      <button
        type="button"
        class="kulta-product-heart"
        data-kulta-favorite-toggle
        data-product-id="${escapeKultaAttribute(normalized.id || '')}"
        data-product-handle="${escapeKultaAttribute(normalized.handle || '')}"
        data-product-title="${escapeKultaAttribute(title)}"
        data-product-url="${escapeKultaAttribute(url)}"
        data-product-price="${escapeKultaAttribute(price)}"
        data-product-image="${escapeKultaAttribute(normalized.image || '')}"
        aria-label="Save ${escapeKultaAttribute(title)} to favorites"
        aria-pressed="false"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l7.78-7.78a5.5 5.5 0 0 0 1.06-8.84z"></path></svg>
      </button>
      ${kultaQuickAddMarkup(normalized, title)}
    </div>
    <a href="${escapeKultaAttribute(url)}" class="kulta-product-link" aria-label="${escapeKultaAttribute(title)}">
      <div class="kulta-product-info">
        <h3 class="kulta-product-title">${escapeKultaHtml(title)}</h3>
        <span class="kulta-product-price">${escapeKultaHtml(price)}</span>
      </div>
    </a>
  </article>`;
}

function normalizeRecommendedProduct(product) {
  if (!product) return {};

  const images = Array.isArray(product.images) ? product.images : [];
  const image = product.featured_image || product.image || product.image_url || images[0];
  const imageUrl = getKultaImageUrl(image);
  const secondaryImage = getKultaImageUrl(product.secondary_image || product.secondaryImage) || getKultaSecondaryImage(images, imageUrl);
  const rawPrice = product.price || product.price_min || product.variants?.[0]?.price;
  // Tolerant parse: strips "$"/commas so already-formatted prices survive re-normalization
  // (recommendationCardMarkup re-normalizes items that renderKulta* already normalized).
  const priceNum = parseFloat(String(rawPrice ?? '').replace(/[^0-9.\-]/g, ''));
  const variant = getKultaProductVariant(product);

  return {
    id: product.id,
    handle: product.handle,
    title: product.title,
    url: product.url || (product.handle ? `/products/${product.handle}` : ''),
    price: typeof rawPrice === 'number' ? formatKultaMoney(rawPrice) : (Number.isNaN(priceNum) ? '' : formatKultaMoney(Math.round(priceNum * 100))),
    image: imageUrl,
    secondaryImage,
    variantId: product.variant_id || product.variantId || variant.id,
    available: product.available !== false && variant.available !== false,
  };
}

async function fetchKultaRecommendations(seedId, limit) {
  if (!seedId) return [];

  const url = `/recommendations/products.json?product_id=${encodeURIComponent(seedId)}&limit=${encodeURIComponent(limit)}&intent=related`;
  try {
    const response = await fetch(url);
    if (!response.ok) return [];

    const data = await response.json();
    return Array.isArray(data.products) ? data.products : [];
  } catch (error) {
    return [];
  }
}

async function fetchKultaCollectionProducts(handle, limit) {
  if (!handle) return [];
  try {
    const response = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=${encodeURIComponent(limit)}`);
    if (!response.ok) return [];
    const data = await response.json();
    return Array.isArray(data.products) ? data.products : [];
  } catch (error) {
    return [];
  }
}

function normalizeKultaCollectionProduct(product) {
  const images = Array.isArray(product.images) ? product.images : [];
  const imageUrl = getKultaImageUrl(product.featured_image || images[0]);
  const variants = Array.isArray(product.variants) ? product.variants : [];
  /* Prefer a purchasable variant so quick-add never points at a sold-out one. */
  const variant = variants.find((v) => v.available) || variants[0] || {};
  const priceNum = parseFloat(variant.price || product.price || 0);
  return {
    id: product.id,
    handle: product.handle,
    title: product.title,
    url: product.handle ? `/products/${product.handle}` : '',
    price: Number.isNaN(priceNum) ? '' : formatKultaMoney(Math.round(priceNum * 100)),
    image: imageUrl,
    secondaryImage: getKultaImageUrl(images[1]),
    variantId: variant.id,
    available: product.available !== false && (variants.length === 0 || variants.some((v) => v.available !== false)),
  };
}

async function renderKultaProductRecommendations(section) {
  const grid = section.querySelector('[data-kulta-product-recommendations-grid]');
  const status = section.querySelector('[data-kulta-product-recommendations-status]');
  const productId = section.dataset.productId;
  const limit = Number(section.dataset.recommendationsLimit || 4);
  if (!grid || !productId) return;

  const recommendations = await fetchKultaRecommendations(productId, limit);
  let normalized = recommendations.map(normalizeRecommendedProduct).filter((item) => item.handle);

  // Fallback: si Shopify aún no tiene recomendaciones para este producto,
  // mostramos best-sellers (o la colección que se configure) para no dejar vacío.
  if (!normalized.length) {
    const fallbackHandle = section.dataset.recommendationsFallback || 'best-sellers';
    const fallbackProducts = await fetchKultaCollectionProducts(fallbackHandle, limit + 2);
    normalized = fallbackProducts
      .map(normalizeKultaCollectionProduct)
      .filter((item) => item.handle && String(item.id) !== String(productId));
  }

  if (!normalized.length) {
    if (status) status.textContent = 'Recommendations will appear as Shopify learns this product';
    return;
  }

  if (status) status.hidden = true;
  grid.innerHTML = normalized.slice(0, limit).map(recommendationCardMarkup).join('');
  initKultaTheme(grid);
  updateFavoriteButtons(grid);
}

function initKultaProductRecommendations(root) {
  root.querySelectorAll('[data-kulta-product-recommendations]').forEach((section) => {
    if (section.dataset.kultaProductRecommendationsReady) return;
    section.dataset.kultaProductRecommendationsReady = 'true';
    renderKultaProductRecommendations(section);
  });
}

async function renderKultaRecommendedPage(page) {
  const grid = page.querySelector('[data-kulta-recommended-grid]');
  const label = page.querySelector('[data-kulta-recommended-label]');
  const empty = page.querySelector('[data-kulta-recommended-empty]');
  if (!grid) return;

  const limit = Number(page.dataset.recommendationLimit || 8);
  const fallbackLabel = page.dataset.fallbackLabel || label?.textContent || 'Personal edit';
  const hasFallbackProducts = page.dataset.hasFallbackProducts === 'true' && page.kultaFallbackMarkup?.trim();
  const saved = readKultaFavorites();
  const recent = readKultaRecentProducts();
  const seeds = [...saved, ...recent].filter((item) => item.id && item.handle);
  const uniqueSeeds = [];
  const seedHandles = new Set();

  seeds.forEach((seed) => {
    if (seedHandles.has(seed.handle)) return;
    uniqueSeeds.push(seed);
    seedHandles.add(seed.handle);
  });

  if (!uniqueSeeds.length) {
    if (label) label.textContent = fallbackLabel;
    if (hasFallbackProducts) {
      grid.innerHTML = page.kultaFallbackMarkup;
      if (empty) empty.hidden = true;
      initKultaTheme(grid);
      updateFavoriteButtons(grid);
    } else {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
    }
    return;
  }

  if (label) label.textContent = 'Building your edit';
  const batches = await withKultaLoader(() => Promise.all(uniqueSeeds.slice(0, 3).map((seed) => fetchKultaRecommendations(seed.id, limit))));
  const seen = new Set(seedHandles);
  const recommendations = [];

  batches.flat().forEach((product) => {
    const normalized = normalizeRecommendedProduct(product);
    const key = normalized.handle || String(normalized.id || '');
    if (!key || seen.has(key)) return;
    seen.add(key);
    recommendations.push(normalized);
  });

  if (!recommendations.length) {
    if (label) label.textContent = fallbackLabel;
    if (hasFallbackProducts) {
      grid.innerHTML = page.kultaFallbackMarkup;
      if (empty) empty.hidden = true;
      initKultaTheme(grid);
      updateFavoriteButtons(grid);
    } else if (empty) {
      grid.innerHTML = '';
      empty.hidden = false;
    }
    return;
  }

  if (empty) empty.hidden = true;
  if (label) label.textContent = saved.length ? 'Based on your saved pieces' : 'Based on recently viewed pieces';
  grid.innerHTML = recommendations.slice(0, limit).map(recommendationCardMarkup).join('');
  initKultaTheme(grid);
  updateFavoriteButtons(grid);
}

function initKultaRecommendedPage(root) {
  root.querySelectorAll('[data-kulta-recommended-page]').forEach((page) => {
    if (page.dataset.kultaRecommendedReady) return;
    page.dataset.kultaRecommendedReady = 'true';
    const grid = page.querySelector('[data-kulta-recommended-grid]');
    page.kultaFallbackMarkup = grid ? grid.innerHTML : '';
    renderKultaRecommendedPage(page);
  });
}

function escapeKultaHtml(value) {
  return String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[char]);
}

function escapeKultaAttribute(value) {
  return escapeKultaHtml(value);
}

/* ── AJAX Add-to-Cart ──────────────────────────────────────────────────── */

function initKultaAjaxCart(root) {
  const cartForms = root.querySelectorAll('.prod-quick-add-form, .kulta-quick-add-form, .kulta-product-form');

  cartForms.forEach((form) => {
    if (form.dataset.kultaAjaxCartReady) return;
    form.dataset.kultaAjaxCartReady = 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const submitBtn = form.querySelector('button[type="submit"]');
      if (!submitBtn || submitBtn.disabled) return;

      const originalHtml = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span>Adding\u2026</span>';

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Could not add to bag');
        }

        showKultaToast('Added to bag');
        syncKultaCartCount();
        document.dispatchEvent(new CustomEvent('kulta:cart:added'));

        submitBtn.innerHTML = '<span>Added ✓</span>';
        window.setTimeout(() => {
          submitBtn.innerHTML = originalHtml;
          submitBtn.disabled = false;
        }, 1400);
      } catch (error) {
        showKultaToast(error.message || 'Could not add to bag');
        submitBtn.innerHTML = originalHtml;
        submitBtn.disabled = false;
      }
    });
  });
}

function syncKultaCartCount() {
  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      document.querySelectorAll('[data-kulta-cart-count]').forEach((badge) => {
        const count = cart.item_count || 0;
        badge.textContent = count;
        badge.hidden = count < 1;
      });
    })
    .catch(() => {});
}

/* ── Predictive Search Keyboard Navigation ─────────────────────────────── */

function initKultaSearchKeyboard(form) {
  const input = form.querySelector('[data-kulta-predictive-input]');
  const results = form.querySelector('[data-kulta-predictive-results]');
  if (!input || !results || form.dataset.kultaSearchKeyboardReady) return;
  form.dataset.kultaSearchKeyboardReady = 'true';

  let activeIndex = -1;

  const getItems = () => results.querySelectorAll('.kulta-predictive-item, .kulta-predictive-view-all');

  const clearActive = () => {
    getItems().forEach((item) => {
      item.classList.remove('kulta-predictive-active');
      item.setAttribute('aria-selected', 'false');
    });
    input.removeAttribute('aria-activedescendant');
    activeIndex = -1;
  };

  const setActive = (index) => {
    const items = getItems();
    if (!items.length) return;
    clearActive();
    activeIndex = ((index % items.length) + items.length) % items.length;
    if (!items[activeIndex].id) items[activeIndex].id = `${results.id || 'KultaPredictiveResults'}-option-${activeIndex}`;
    items[activeIndex].classList.add('kulta-predictive-active');
    items[activeIndex].setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', items[activeIndex].id);
    items[activeIndex].scrollIntoView({ block: 'nearest' });
  };

  input.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      clearActive();
      return;
    }
    if (results.hidden) return;

    const items = getItems();
    if (!items.length) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setActive(activeIndex + 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setActive(activeIndex - 1);
    } else if (event.key === 'Enter' && activeIndex >= 0) {
      event.preventDefault();
      const active = items[activeIndex];
      if (active?.href) window.location.href = active.href;
    }
  });

  input.addEventListener('input', clearActive);
}
